function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { styled, css } from 'styled-components';
import { attachSubComponents, getChildByType } from '../../util';
import { AvatarContext } from './AvatarContext';
import { Monogram } from './Monogram';
import { Icon } from './Icon';
import { Image } from './Image';
const sizeMap = {
  sm: '1.5rem',
  md: '2rem',
  lg: '3rem',
  xl: '4.5rem'
};
export const AVATAR_SIZES = Object.keys(sizeMap);
const StyledAvatar = styled.div.withConfig({
  componentId: "aui__sc-1yxt155-0"
})(["background-color:var(--aui-primary-soft);color:var(--aui-on-primary-soft);border-radius:50%;display:inline-flex;align-items:center;", " ", " overflow:hidden;"], ({
  $hasMonogram
}) => !$hasMonogram && css(["justify-content:center;"]), ({
  $size
}) => css(["width:", ";height:", ";"], sizeMap[$size], sizeMap[$size]));
export const Avatar = attachSubComponents('Avatar', /*#__PURE__*/React.forwardRef(({
  size = 'md',
  children,
  ...props
}, fRef) => {
  const hasMonogram = !!getChildByType(children, Monogram);
  return /*#__PURE__*/React.createElement(AvatarContext.Provider, {
    value: {
      size
    }
  }, /*#__PURE__*/React.createElement(StyledAvatar, _extends({
    "data-aui": "avatar",
    $size: size,
    $hasMonogram: hasMonogram,
    ref: fRef
  }, props), children));
}), {
  Monogram,
  Icon,
  Image
});